import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui';
import { useAuth } from '@/hooks/useAuth';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.xl};
  background: ${({ theme }) => theme.colors.background};
  direction: rtl;
  text-align: center;
`;

const ErrorCode = styled.div`
  font-size: 8rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  font-family: ${({ theme }) => theme.fonts.primary};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 6rem;
  }
`;

const Title = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes['2xl']};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  font-family: ${({ theme }) => theme.fonts.primary};
`;

const Message = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  max-width: 600px;
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: 1.6;
`;

const Illustration = styled.div`
  font-size: 6rem;
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  opacity: 0.5;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  flex-wrap: wrap;
  justify-content: center;
`;

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleGoHome = () => {
    // If user is authenticated, go to dashboard, otherwise go to landing page
    navigate(user ? '/dashboard' : '/');
  };

  return (
    <Container>
      <Illustration>🔍</Illustration>
      <ErrorCode>404</ErrorCode>
      <Title>הדף לא נמצא</Title>
      <Message>
        מצטערים, הדף שחיפשת לא קיים או הועבר למיקום אחר.
        <br />
        אנא בדוק את הכתובת או חזור לדף הבית.
      </Message>

      <ButtonGroup>
        <Button onClick={handleGoHome} variant="primary">
          {user ? 'חזור ללוח הבקרה' : 'חזור לדף הבית'}
        </Button>
        <Button onClick={() => navigate(-1)} variant="secondary">
          חזור לדף הקודם
        </Button>
      </ButtonGroup>
    </Container>
  );
};

export default NotFoundPage;
